import { FC } from 'react';
import Skeleton from 'react-loading-skeleton';
import LoaderMain from 'components/shared/LoaderMain';
import ResultLoadingModal from '../ResultLoadingModal';
import { b2b } from 'constants/generic';

const ResultsFilterSkeleton: FC = () => {
  return (
    <>
      <div className="hotel-list" style={{ marginTop: 27, minWidth: '85%' }}>
        {Array(5)
          .fill('1')
          .map((_, index) => {
            return (
              <div className="hotel-card-wrapper" key={index}>
                <div className="hotel-card">
                  <div className="hotel-card-img">
                    <Skeleton width={'100%'} height={'100%'} />
                  </div>
                  <div className="hotel-card-info">
                    <div className="title mb-5">
                      <Skeleton width={'80%'} height={25} />
                    </div>
                    <div className="address">
                      <Skeleton width={160} height={16.5} />
                    </div>
                    <div className="location-from">
                      <Skeleton width={120} height={16.5} />
                    </div>
                    <div className="show-rooms">
                      <Skeleton width={150} height={16.5} />
                    </div>
                  </div>
                  <div className="hotel-card-total">
                    <div className="nights">
                      <Skeleton width={90} height={16.5} />
                    </div>
                    <div className="price-wrapper">
                      <div className="price">
                        <Skeleton width={80} height={25} />
                      </div>
                      <Skeleton width={25} height={25} style={{ borderRadius: '50%' }} />
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
      </div>

      {b2b ? <ResultLoadingModal /> : <LoaderMain systemProducts="Hotels" />}
    </>
  );
};

export default ResultsFilterSkeleton;
